import React from 'react';
import usePBVisibility from '../../../../hooks/pagebuilder/usePBVisibility';
import { UiComponent } from '../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import { UiComponentBackground } from '../../pageBuilder/UiComponentBackground';
import UIComponentElement from './UIComponents/UIComponentElement';

const WithoutPageBuilder = () => {
  const pageData = useSelector((state) => state.common.pagedata);

  const { showComponent } = usePBVisibility();

  return (
    <div className="w-full min-h-screen flex flex-col z-10 relative">
      {pageData?.uicomponents
        ?.filter((component) => showComponent(component))
        .map((component: UiComponent) => (
          <div
            key={component._id}
            className="w-full"
            style={{
              height: 'auto',
              position: 'relative',
              display: 'grid',
              placeItems: 'center',
            }}>
            <UiComponentBackground component={component} />
            <UIComponentElement uiComponent={component as any} restrictWidth />
          </div>
        ))}
    </div>
  );
};

export default WithoutPageBuilder;
